import React, {
  ReactNode, useContext,
} from 'react';

import { useStore } from '../store-provider/state.context';
import { ApiContext } from '../api-provider';
import { IApiService } from '../../../store/services/api-service';
import {
  ActionsContext, useGetActions,
} from './actions.context';
import { useDispatch } from '../store-provider/dispatch.context';
import { useLocalStorage } from '../local-storage-provider/local-storage.context';

interface IStoreProviderProps {
  children: ReactNode;
}

const ActionsProvider = ({ children }: IStoreProviderProps): JSX.Element => {
  const state = useStore();
  const dispatch = useDispatch();
  const localStorageService = useLocalStorage();
  const api = useContext<IApiService>(ApiContext);
  // eslint-disable-next-line no-console
  const actions = useGetActions(state, dispatch, api, localStorageService);

  return (
    <ActionsContext.Provider value={actions}>
      {children}
    </ActionsContext.Provider>
  );
};

ActionsProvider.displayName = 'ActionsProvider';

export default ActionsProvider;
